import { reactive, ref } from "vue";

interface ActiveRoomState {
  mode: "grid" | "one" | "stream" | "speaker";
  //TODO: Сделать в единственном месте
  selfApiConnected: boolean
  allMute?: string
}

export const activeRoomState = reactive<ActiveRoomState>({
  mode: "grid",
  selfApiConnected: false
});

let lastMode: ActiveRoomState['mode'] = "grid"
export function setStreamMode() {
  if(activeRoomState.mode !== "stream") {
    lastMode = activeRoomState.mode
    activeRoomState.mode = 'stream'
  }
}

export function restoreMode() {
  activeRoomState.mode = lastMode
}

export const youLeaveState = ref(false);
